import styled from "styled-components";
import { BorderSolidLightBlue } from "../BorderSolidLightBlue";
export const BlueFrameBox = styled.div `
    margin: 15px;
    ${BorderSolidLightBlue};
    padding: 0 10px;
    overflow: hidden;
`;
